module.exports = __webpack_public_path__ + "img/manageServices.206f4f1.svg";